"use strict";

function addNewIntroSection() {
  document.getElementById('newIntroSection').style.display = 'block';
  document.getElementById('destroy_newsection').value = false

}

function cancelNewIntroSection() {
  document.getElementById('newIntroSection').style.display = 'none';
  document.getElementById('destroy_newsection').value = true
}

function clearPrivateInfo(private_info_selector){
  let obj = document.querySelector(private_info_selector);
  const info = obj.value;
  if(info === gon.private_info){
    obj.value = '';
  }
}

function showPrivateInfo(obj){
  const info = obj.value;
  if(info === ''){
    obj.value = gon.private_info;
  }
}

export {
  addNewIntroSection,
  cancelNewIntroSection,
  clearPrivateInfo,
  showPrivateInfo
};
